/**
 * Shared docket-item helpers used by Schedule.jsx and Dockets.jsx editors.
 */

/**
 * Return a shallow copy of `item` with all min-hire artefacts removed.
 * Used when the user edits qty or uom so the stale billed value
 * doesn't hang around until the next backend save.
 */
export const clearMinHire = (item) => {
  const { billed_qty, min_hire_applied, min_hire_qty, min_hire_note, ...rest } = item;
  return rest;
};
